import { Button, Form, Input, Typography } from "antd";
import React, { useState } from "react";

import { useDispatch } from "react-redux";
import { addCustomer } from "../../redux/rtk/features/user/userSlice";

import { Navigate } from "react-router";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import getRoleFromToken from "../../utils/getRoleFromToken";
import { IoMailOutline, IoLockClosedOutline, IoSparklesOutline, IoArrowForward } from "react-icons/io5";
import umtLogo from "../../assets/images/umt-logo.png";
import "./CustomerLogin.css";

const { Title } = Typography;

const CustomerLogin = () => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const isLogged = Boolean(localStorage.getItem("isLogged"));

  if (isLogged) {
    return <Navigate to={"/customer/dashboard"} replace={true} />;
  }

  const onFinish = async (values) => {
    const resp = await dispatch(addCustomer(values));
    if (resp.payload.message === "success") {
      setLoader(false);
      if (getRoleFromToken() === "customer") {
        window.location.href = "/customer/dashboard";
      }
    } else {
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setLoader(false);
    toast.error("Error at login Please try again");
  };

  return (
    <div className="customer-login-page">
      <div className="customer-login-shell">
        <div className="customer-login-brand">
          <img src={umtLogo} alt="UMT Logo" className="customer-login-logo" />
          <span className="customer-login-eyebrow">
            <IoSparklesOutline /> Campus Pulse Portal
          </span>
          <h2 className="customer-login-brand-title">Welcome back</h2>
          <p className="customer-login-brand-text">
            Sign in to manage your posts, track your submissions, and stay connected with the UMT
            community.
          </p>
        </div>

        <div className="customer-login-form-panel">
          <Title level={3} className="customer-login-title">
            User Login
          </Title>
          <p className="customer-login-subtitle">Enter your credentials to continue</p>

          <Form
            name="basic"
            wrapperCol={{
              span: 24,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            className="customer-login-form"
          >
            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please input your email or username!",
                },
              ]}
            >
              <Input size="large" prefix={<IoMailOutline />} placeholder="Enter email" />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
              ]}
            >
              <Input.Password size="large" prefix={<IoLockClosedOutline />} placeholder="Enter password" />
            </Form.Item>

            <Form.Item className="customer-login-submit-wrap">
              <Button
                block
                type="primary"
                htmlType="submit"
                loading={loader}
                onClick={() => setLoader(true)}
                className="customer-login-submit"
              >
                Sign In <IoArrowForward />
              </Button>
            </Form.Item>

            <Link to={"/customer/forget-password"} className="customer-login-forgot">
              Forgot password?
            </Link>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default CustomerLogin;
